import type { PlanEntitlementsRow } from '../../shell/feature-flags/domain/planEntitlements';
import { countAllCatalogProducts } from '../infra/catalogReadRepo';
import { CatalogDomainError } from '../domain/catalogErrors';

export class CatalogPlanLimitExceededError extends CatalogDomainError {
  readonly title = 'Límite de plan alcanzado';

  constructor(maxProducts: number, currentTotal: number) {
    super(
      'CATALOG_PLAN_LIMIT_EXCEEDED',
      `Tu plan permite hasta ${maxProducts} productos y ya tenés ${currentTotal}. Cambiá de plan o eliminá/ocultá productos que no uses.`
    );
  }
}

export async function assertWithinProductPlanLimit(planEnt: PlanEntitlementsRow | null): Promise<void> {
  if (planEnt?.max_products == null) return;
  const total = await countAllCatalogProducts();
  if (total >= planEnt.max_products) {
    throw new CatalogPlanLimitExceededError(planEnt.max_products, total);
  }
}

export function getCatalogPlanLimitExceededMessage(error: CatalogPlanLimitExceededError): {
  title: string;
  message: string;
} {
  return { title: error.title, message: error.message };
}
